<template>
	<div class="space-y-1">
		<label class="block text-sm font-medium text-gray-700">{{ label }}</label>
		<div class="gap-2 flex items-center">
			<button
				v-for="statusOption in statusOptions"
				:key="statusOption.value"
				@click="updateValue(statusOption.value)"
				class="px-3 py-2 rounded-md cursor-pointer transition-all duration-200 text-sm font-medium outline outline-2 outline-offset-2"
				:class="modelValue === statusOption.value ? 'outline-black' : 'bg-white text-gray-700 outline-white/0 hover:outline-black/20 hover:bg-gray-50'"
			>
				{{ statusOption.label }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'StatusFilter',
	props: {
		modelValue: {
			type: String,
			default: 'available'
		},
		label: {
			type: String,
			default: 'Status'
		}
	},
	emits: ['update:modelValue'],
	data() {
		return {
			statusOptions: [
				{ label: 'Available', value: 'available' },
				{ label: 'Under offer', value: 'underOffer' },
				{ label: 'Sold', value: 'sold' }
			]
		}
	},
	methods: {
		updateValue(value) {
			this.$emit('update:modelValue', value)
		}
	}
}
</script>